import type { FlowType } from '@/store/SessionStore';

export interface UTag {
  link: (params: Record<string, unknown>) => void;
  view: (params: Record<string, unknown>) => void;
}

export type ActivityType = 'view' | 'link';

export interface TagParams {
  sessionid: string;
  page: string;
  flow: FlowType;
  trv_end_location?: string;
  cta?: string;
  confirmation_id?: string;
  category?: Array<string>;
  comm_pref?: string;
  contact_type?: string;
  hd_schdlr_1?: string;
  hd_schdlr_2?: string;
  custID?: string;
  quantity?: Array<string>;
  product?: Array<string>;
  error?: string;
}

export interface Flows {
  new: string;
  modify: string;
  cancel: string;
  email: string;
  emailModify: string;
  emailCancel: string;
}

export interface Pages {
  destination: string;
  appointmentOption: string;
  selectAppointment: string;
  selectAgent: string;
  contactInfo: string;
  confirmation: string;
  cancelAppointment: string;
  errorPage: string;
  noAppointmentsAcceptedModal: string;
  agentsUnavailableModal: string;
}

export interface CTAS {
  pickAnotherAgent: string;
}

export const Page: Pages = {
  destination: 'travel:scheduler:destination',
  appointmentOption: 'travel:scheduler:appointment option',
  selectAppointment: 'travel:scheduler:select appointment',
  selectAgent: 'travel:scheduler:agent selection',
  contactInfo: 'travel:scheduler:contact information',
  confirmation: 'travel:scheduler:confirmation',
  cancelAppointment: 'travel:scheduler:cancel appointment',
  errorPage: 'travel:scheduler:error',
  noAppointmentsAcceptedModal: 'travel:scheduler:no appointments',
  agentsUnavailableModal: 'travel:scheduler:agents unavailable',
};

export const Flow: Flows = {
  new: 'new',
  modify: 'new:modify',
  cancel: 'new:cancel',
  email: 'email',
  emailModify: 'email:modify',
  emailCancel: 'email:cancel',
};
